import { SERVER_URL } from "../../api";
import axios from 'axios';
import { getHeaderWithToken } from "../../helpers/func";

export const VIEW_SECTION_REQUEST = 'VIEW_SECTION_REQUEST';
export const VIEW_SECTION_SUCCESS = 'VIEW_SECTION_SUCCESS';
export const VIEW_SECTION_ERROR = 'VIEW_SECTION_ERROR';
export const RESET_VIEW_SECTION = 'RESET_VIEW_SECTION';


export const viewSection = (id) => {
    let headers = getHeaderWithToken();


    return dispatch => {
        return new Promise(function (resolve, reject) {
            dispatch({
                type: VIEW_SECTION_REQUEST
            })
            axios({
                method: 'GET',
                url: `${SERVER_URL}v1/patterns/section/${id}`,
                headers: headers,

            }).then(function (response) {
                dispatch({
                    type: VIEW_SECTION_SUCCESS,
                    payload: response
                })
                resolve(response);
            })
                .catch(function (error) {
                    dispatch({
                        type: VIEW_SECTION_ERROR,
                        payload: error
                    })
                    reject(error)
                })
        })

    }


}

export const resetViewSection = () => {
    return dispatch => {
        dispatch({
            type: RESET_VIEW_SECTION
        })
    }
}
